module.exports = __webpack_public_path__ + "img/environment1.f3eab28f.png";